import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { InventoryEntities } from 'client/data/models/inventory';
import { PricingDetails as PricingDetailsSRP } from 'site-modules/shared/components/usurp-inventory-card/pricing-details-srp';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { ClickableCardLink } from 'site-modules/shared/components/inventory/clickable-card/clickable-card-link/clickable-card-link';
import { UsurpInventoryCardVdpLink } from 'site-modules/shared/components/usurp-inventory-card/usurp-inventory-card-vdp-link';
import { DealerFeesLink } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-link';

export function UsurpInventoryCardInfo({
  vehicle,
  selectedPaymentType = '',
  ariaLabel = '',
  includeDeliveryFee = false,
  vehicleNameDisplay = '',
  vdpLink = '',
  nameTag: NameTag = 'h2',
  isVinPreviewLink = false,
  isLeaseCardWithLeasePayment = false,
  isLoanCardWithLoanPayment = false,
  openLinksInNewTab = false,
  isVinPreview = false,
  trackingCreativeId = undefined,
}) {
  const { type } = vehicle;
  const isNewType = isNew(type);

  return (
    <Row className="info-wrapper mx-0 pb-0_75 flex-nowrap justify-content-between">
      <Col xs={7} className="left-section py-0 ps-0 pe-0_5">
        <NameTag className="mb-0">
          <ClickableCardLink
            linkComponent={UsurpInventoryCardVdpLink}
            className="wrapping-vdp-link"
            vehicle={vehicle}
            vdpLink={vdpLink}
            ariaLabel={ariaLabel}
            openLinksInNewTab={openLinksInNewTab}
            isVinPreviewLink={isVinPreviewLink}
            isVinPreview={isVinPreview}
            trackingCreativeId={trackingCreativeId}
          >
            {vehicleNameDisplay}
          </ClickableCardLink>
        </NameTag>
      </Col>
      <Col xs={5} className="pe-0 text-end d-flex justify-content-between">
        <div className="border-start h-100 ps-0_5" />
        <PricingDetailsSRP
          vehicle={vehicle}
          displayLeaseMonthlyPayment={isLeaseCardWithLeasePayment}
          displayLoanMonthlyPayment={isLoanCardWithLoanPayment}
          displayMSRP={isNewType && !selectedPaymentType}
          includeDeliveryFee={includeDeliveryFee}
          dealerFeesLink={
            <DealerFeesLink
              vehicle={vehicle}
              isLeaseOrLoan={isLeaseCardWithLeasePayment || isLoanCardWithLoanPayment}
            />
          }
        />
      </Col>
    </Row>
  );
}

UsurpInventoryCardInfo.propTypes = {
  vehicle: InventoryEntities.InventoryVin.isRequired,
  selectedPaymentType: PropTypes.string,
  ariaLabel: PropTypes.string,
  includeDeliveryFee: PropTypes.bool,
  vehicleNameDisplay: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  vdpLink: PropTypes.string,
  nameTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  isVinPreviewLink: PropTypes.bool,
  isLeaseCardWithLeasePayment: PropTypes.bool,
  isLoanCardWithLoanPayment: PropTypes.bool,
  openLinksInNewTab: PropTypes.bool,
  isVinPreview: PropTypes.bool,
  trackingCreativeId: PropTypes.string,
};
